import React from "react";
import { Chat } from "../components/Chat";

export const Chats = ({ eventData, eventID }) => {
  const { groupCount, isPrivate, requireCheckIn } = eventData;
  // Without mixer check-in nobody is ever "checked-in", so that notify target
  // is hidden and the default becomes everyone (the server maps it the same way).
  const usesCheckIn = requireCheckIn !== false;

  return (
    <div className={`grid lg:grid-cols-${groupCount} gap-4 grid-cols-1`}>
      {
        groupCount > 1 && (
          <Chat
            title="Movers's Chat"
            subCollectionName={"moversChat"}
            isPrivate={isPrivate}
            requireCheckIn={usesCheckIn}
            parentID={eventID}
          />
        )
      }

      <Chat
        title="Sitters's Chat"
        subCollectionName={"sittersChat"}
        isPrivate={isPrivate}
        requireCheckIn={usesCheckIn}
        parentID={eventID}
      />
    </div>
  );
};
